import { useMedia, useTheme, minusOnePx } from "@catchoftheday/cg-components";
export var useIsTabletView = function useIsTabletView() {
  var theme = useTheme();
  return useMedia(["(min-width: ".concat(theme.breakpoints.md, ") and (max-width: ").concat(minusOnePx(theme.breakpoints.lg, true), ")")], [true]);
};